import React from 'react'
import './imgswitch.css'
import 'bootstrap/dist/css/bootstrap.css';
import Carousel from 'react-bootstrap/Carousel';
export default function imgswitch() {
  return (
    <div className='switch'>
      {/* Images flipping */}
      <div className="c1">
        <Carousel>
          <Carousel.Item interval={1000}>
            <img className="images" src="./img1.jpg" alt="I1" />
          </Carousel.Item>
          <Carousel.Item interval={1000}>
            <img className="images" src="./img2.jpg" alt="I2" />
          </Carousel.Item>
          <Carousel.Item interval={1000}>
            <img className="images" src="./img3.jpg" alt="I3" />
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  )
}
